"use client";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Row,
  Typography,
  Col,
  Button,
  Space,
  Spin,
  Modal,
  Form,
  Input,
  Select,
  Card,
  Divider,
} from "antd";
import {
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { BOM } from "../../../../services/definedMethod";
import {
  apiConfig,
  staticConfig,
  labelConfig,
} from "../../serviceProvider.config";
import cnt from "../../../../services/definedConstant";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";
import CustomButton from "../../../../components/custom/CustomButton";
import { useNavigate } from "react-router-dom";
import Notiflix from "notiflix";

const { Text, Title } = Typography;

function AddressInfoTab(props) {
  const { currentCustomerObj, userData, refreshList } = props;
  const { session } = userData;

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [addressDetails, setAddressDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMode, setModalMode] = useState("create");
  const [currentAddressId, setCurrentAddressId] = useState(null);
  const [selectedAddressType, setSelectedAddressType] = useState(null);

  // Template Data for Modal
  const [templateData, setTemplateData] = useState({
    countryIdOptions: [],
    stateProvinceIdOptions: [],
    addressTypeIdOptions: [],
  });

  useEffect(() => {
    getAddresses();
    getTemplate();
  }, [currentCustomerObj.id]);

  const getAddresses = () => {
    setIsLoading(true);
    const url = `${apiConfig.Client}/${currentCustomerObj.id}/addresses`;
    BOM.FetchReqAction({ session }, url, (err, res) => {
      setIsLoading(false);
      if (err) return BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      setAddressDetails(res);
    });
  };

  const getTemplate = () => {
    const url = `${apiConfig.Client}/addresses/template`;
    BOM.FetchReqAction({ session }, url, (err, res) => {
      if (!err) {
        setTemplateData({
          countryIdOptions: res.countryIdOptions.map((o) => ({
            label: o.name,
            value: o.id,
          })),
          stateProvinceIdOptions: res.stateProvinceIdOptions.map((o) => ({
            label: o.name,
            value: o.id,
          })),
          addressTypeIdOptions: res.addressTypeIdOptions.map((o) => ({
            label: o.name,
            value: o.id,
          })),
        });
      }
    });
  };

  const handleOpenModal = (mode, record = null) => {
    setModalMode(mode);
    setIsModalVisible(true);
    if (mode === "edit" && record) {
      setCurrentAddressId(record.addressId);
      form.setFieldsValue({
        addressTypeId: record.addressTypeId,
        addressLine1: record.addressLine1,
        addressLine2: record.addressLine2,
        city: record.city,
        stateProvinceId: record.stateProvinceId,
        countryId: record.countryId,
        postalCode: record.postalCode,
      });
    } else {
      form.resetFields();
    }
  };
  const handleSelectedAddressTypeId = (keyParam) => {
    console.log(keyParam);
    setSelectedAddressType(keyParam);
  };

  const handleModalSubmit = (formValues) => {
    delete formValues.addressTypeId;
    setIsLoading(true);
    const isEdit = modalMode === "edit";
    const url = `${apiConfig.Client}/${currentCustomerObj.id}/addresses?type=${selectedAddressType}`;

    const body = {
      ...formValues,
      addressId: isEdit ? currentAddressId : undefined,
      method: isEdit ? "PUT" : "POST",
      session,
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        setIsLoading(false);
        if (err)
          return BOM.AlertMsg(
            cnt.DANGER,
            err?.errors?.[0]?.defaultUserMessage || "Error"
          );

        BOM.AlertMsg(
          cnt.SUCCESS,
          isEdit ? "Address updated successfully" : "Address added successfully"
        );
        setIsModalVisible(false);
        getAddresses();
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: () => {
          setIsModalVisible(false);
          getAddresses();
        },
      }
    );
  };

  const handleDelete = (param) => {
    Modal.confirm({
      title: "Remove Address",
      content: "Are you sure you want to remove this address?",
      okText: "Yes, Remove",
      okType: "danger",
      cancelText: "No",
      onOk: () => {
        console.log("Removing address:", param.addressId);
      },
    });
  };

  const handleDisableOrEnable = (param) => {
    let payload = {};
    payload.isActive = param?.isActive === true ? "false" : "true";
    payload.addressId = param?.addressId;

    Notiflix.Confirm.show(
      "Are you sure?",
      `Do you want to disable the ${param.addressType} address?`,
      "Yes",
      "No",
      function () {
        setIsLoading(true);
        const url = `${apiConfig.Client}/${currentCustomerObj.id}/addresses`;

        let body = {
          ...payload,
          method: "PUT",
          session,
        };

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            setIsLoading(false);
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            } else {
              BOM.AlertMsg(
                cnt.SUCCESS,
                param?.isActive === true
                  ? labelConfig.disableSuccessMsg
                  : labelConfig.enableSuccessMsg
              );
              getAddresses();
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              setIsLoading(false);
            },
          }
        );
      },
      function () {
        // No/Cancel action
      }
    );
  };

  return (
    <div style={{ padding: "24px 0px", width: "100%" }}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
        <Col>
          <Title level={4} style={{ margin: 0, color: "#344054" }}>
            Address Information
          </Title>
        </Col>
        <Col>
          <Button
            type="default"
            icon={<PlusOutlined />}
            onClick={() => handleOpenModal("create")}
            style={{
              borderRadius: "8px",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
            }}
          >
            Add address
          </Button>
        </Col>
      </Row>

      <Spin spinning={isLoading}>
        <Space direction="vertical" style={{ width: "100%" }} size={16}>
          {addressDetails.map((item, index) => (
            <AddressItemCard
              key={index}
              data={item}
              onEdit={() => handleOpenModal("edit", item)}
              onRemove={() => handleDisableOrEnable(item)}
            />
          ))}
        </Space>
      </Spin>

      <Modal
        title={modalMode === "create" ? "Add address" : "Edit address"}
        open={isModalVisible}
        confirmLoading={isLoading}
        footer={null}
        // onCancel={handleCancel}
        width={1000}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleModalSubmit}
          style={{ marginTop: 20 }}
        >
          <Row>
            <Divider />

            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.addressTypeId}
                  name={"addressTypeId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.addressTypeId),
                    },
                  ]}
                >
                  <Select
                    className="read-only-select"
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.addressTypeId,
                      "select"
                    )}
                    options={templateData.addressTypeIdOptions}
                    disabled={modalMode === "edit"}
                    showSearch
                    onChange={handleSelectedAddressTypeId}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.addressOne}
                  name={"addressLine1"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.addressOne),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.addressOne
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.addressTwo} name={"addressLine2"}>
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.addressTwo
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.city}
                  name={"city"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.city),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.city)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.country}
                  name={"countryId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.country),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.country,
                      "select"
                    )}
                    options={templateData.countryIdOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.stateProvince}
                  name={"stateProvinceId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.stateProvince),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.stateProvince,
                      "select"
                    )}
                    options={templateData.stateProvinceIdOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.postalCode} name={"postalCode"}>
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.postalCode
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.addressStatus}
                  name={"isActive"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.addressStatus),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.addressStatus}`,
                      "select"
                    )}
                    options={staticConfig.statusData}
                    showSearch
                  />
                </Form.Item>
              </Col>
            </Row>
          </Row>

          <Row>
            <Divider />
            <CustomButton
              content="Save"
              style={{
                backgroundColor: "#BA24D5",
                color: "white",
                border: "1px solid #BA24D5",
                borderRadius: 8,
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                fontSize: "16px",
                fontWeight: "600",
                width: "10%",
                marginLeft: "auto",
              }}
              htmlType="submit"
              backgroundColor="#92428B"
              colorText="white"
              hoverBackground="#AD4EA7"
            />

            <CustomButton
              content="Cancel"
              style={{
                backgroundColor: "#BA24D5",
                color: "white",
                border: "1px solid #BA24D5",
                borderRadius: 8,
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                fontSize: "16px",
                fontWeight: "600",
                marginLeft: "1%",
                width: "10%",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={() => setIsModalVisible(false)}
            />
          </Row>
        </Form>
      </Modal>
    </div>
  );
}

// THE NEW CARD UI COMPONENT
const AddressItemCard = ({ data, onEdit, onRemove }) => {
  return (
    <Card
      bodyStyle={{ padding: "16px 24px" }}
      style={{
        borderRadius: "12px",
        border: "1px solid #EAECF0",
        backgroundColor: "#F9FAFB80",
      }}
    >
      <Row justify="space-between" align="middle">
        <Col span={18}>
          <Text
            strong
            style={{
              display: "block",
              fontSize: "16px",
              color: "#344054",
              marginBottom: 4,
            }}
          >
            {data.addressType || "Postal Address"}
          </Text>
          <Text style={{ color: "#667085", fontSize: "14px" }}>
            {`${data.addressLine1}, ${data.city}, ${data.countryName}, ${
              data.postalCode || ""
            }`}
          </Text>
        </Col>
        <Col>
          <Space size={12}>
            <Button
              icon={<EditOutlined />}
              onClick={onEdit}
              style={{ borderRadius: "8px", fontWeight: 500 }}
            >
              Edit
            </Button>
            <Button
              danger
              type="text"
              icon={<StopOutlined />}
              onClick={onRemove}
              style={{ fontWeight: 600, color: "#B42318" }}
            >
              Disable
            </Button>
          </Space>
        </Col>
      </Row>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps)(AddressInfoTab);
